module.exports = __webpack_public_path__ + "images/backgrounds/river/full.7db92b908ffe0fbb4de4.jpg";